import React from 'react';
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import {app} from "./App.js";
export function OYMData(isDataPrivate){
	this.isDataPrivate=isDataPrivate;  // indicates if loaded data is public or private
    this.data = null; // Json object loaded
	this.objectPool = {}; // pool of references to all objects by object id.
	this.fileToLoad='OYMDataPublic.json';
	// this.fileToLoad='OYMDataPublic - Copy.json';
	this.isLoadRequested=false;
	this.doneLoad=function(){
		console.log("doneLoad called before initializing");
	}
	if (isDataPrivate){
		this.fileToLoad='OYMData.json'
	}
	this.setDataPrivate = function(isDataPrivate){
		this.isDataPrivate=isDataPrivate;
		if (isDataPrivate){
			this.fileToLoad='OYMData.json'
		} else {
			this.fileToLoad='OYMDataPublic.json';
		}
	}
	this.timeConstructed=new Date();
	this.oymId = function oymId(){
		return this.timeConstructed.getHours() + ":" + this.timeConstructed.getMinutes() + ":" + this.timeConstructed.getSeconds();
	}
	this.loadData = function(doneLoad){
		console.log("To load data for "+this.fileToLoad,this.data);
		if(this.isLoadRequested){
			console.log("OYM load for "+this.fileToLoad+" already requested. This request to load is ignored.");
			return;
		}
		this.isLoadRequested=true;
		if (this.data!=null){
			console.log("OYM data already loaded for "+this.fileToLoad+". Request to load is ignored.");
			return;
		}
		this.doneLoad=doneLoad;
		this.loadOYMData();
	}
	console.log("OYM object constructed:"+this.fileToLoad+"--"+this.oymId());
	/* objectRegistration will create a pool of all objects accessable by 
	   their object id. 
	   
	*/
    function objectRegistration(objectName,objectToRegister,objectPool){
        // console.log("Starting to register objectName:"+objectName,objectToRegister);
        // console.log("Object pool:",objectPool);
        if (objectToRegister==null){
        	// console.log(objectName+" is null. Ignoring.");
    	    return;
        }
  	    Object.keys(objectToRegister).forEach(key => {
  	        // console.log("In object "+objectName+" starting to examine property "+key);
  	        if (key=="id"){
		        // console.log("found id:", objectToRegister[key],objectToRegister);
  	 	        objectPool[objectToRegister[key]]=objectToRegister;
  	        } else if (typeof objectToRegister[key] == 'object' && objectToRegister[key]!=null){
  	  		    // console.log("found object. Property name:", key);
  	  		    objectRegistration(objectName+"."+key,objectToRegister[key],objectPool);
  	        } else {
  	  		    // console.log("In object "+objectName+" property "+key+" is not object and will not be registered.");
  	        }
  	        // console.log("In object "+objectName+" finished examining property "+key);
  	    });
  	// console.log("checkpoint #4.0 finished registering:"+objectName);
	
  }
  this.ministryAndOversightMembership = [];
  this.buildMinistryAndOversightMembership = function (oymObject){
	if (oymObject.ministryAndOversightMembership.length>0){
		return;
	}
	let ministryAndOversight = oymObject.objectRef(oymObject.data.ministryAndOversight);
	let ministers= oymObject.objectRef(ministryAndOversight.ministers);
	for (let tenurex in ministers.tenuresOfThoseServing[1]){
		let friend = oymObject.objectRef(ministers.tenuresOfThoseServing[1][tenurex].friend);
		let tenure = oymObject.objectRef(ministers.tenuresOfThoseServing[1][tenurex]);
		// console.log("Minister friend,",tenurex,tenure,friend);
		if (oymObject.ministryAndOversightMembership.find(tenureSearch => friend==oymObject.objectRef(tenureSearch.friend))==null){
			oymObject.ministryAndOversightMembership.push(tenure);
		}
	}
	let elders= oymObject.objectRef(ministryAndOversight.elders);
	for (let tenurex in elders.tenuresOfThoseServing[1]){
		let friend = oymObject.objectRef(elders.tenuresOfThoseServing[1][tenurex].friend);
		let tenure = oymObject.objectRef(elders.tenuresOfThoseServing[1][tenurex]);
		// console.log("Elder friend,",tenurex,tenure,friend);
		if (oymObject.ministryAndOversightMembership.find(tenureSearch => friend==oymObject.objectRef(tenureSearch.friend))==null){
			oymObject.ministryAndOversightMembership.push(tenure);
		}

	}
	let overseers= oymObject.objectRef(ministryAndOversight.overseers);

	for (let tenurex in overseers.tenuresOfThoseServing[1]){
		let friend = oymObject.objectRef(overseers.tenuresOfThoseServing[1][tenurex].friend);
		let tenure = oymObject.objectRef(overseers.tenuresOfThoseServing[1][tenurex]);
		// console.log("Overseer friend,",tenurex,tenure,friend);
		if (oymObject.ministryAndOversightMembership.find(tenureSearch => friend==oymObject.objectRef(tenureSearch.friend))==null){
			oymObject.ministryAndOversightMembership.push(tenure);
		}
	}
	// oymObject.ministryAndOversightMembership.sort(oymObject.compareFriend);
  }
  
this.getOYMData = function (oymDataRef){
	// console.log("getOYMData checkpoint 0.5 "+this.oymId());
	return new Promise(function (done) {
		// console.log("getOYMData checkpoint 0.7");
		getDownloadURL(oymDataRef).then((url) => {
			// console.log("getOYMData checkpoint 1.0 ",url);//+this.oymId());
			const xhr = new XMLHttpRequest();
			xhr.responseType = 'json';
			// console.log("getOYMData checkpoint 1.5",url);
			xhr.onload = (event) => {
				const oymdata = xhr.response;
				// console.log("getOYMData checkpoint 2.0");
				// console.log(xhr.response);
				done(xhr);
			  };
			xhr.onabort= (event) => {
				alert("load of "+oymDataRef+" aborted.");
				// console.log("load of "+oymDataRef+" aborted.", event);
			}
			xhr.open('GET', url);
			// console.log("getOYMData checkpoint 3.0",url);
			xhr.send();
			// console.log("getOYMData checkpoint 4.0",url);
			// console.log(xhr.response);
		})
		.catch((error)=>{
			// alert("Error loading "+oymDataRef+" Error:"+error);
			console.log("Error loading "+this.oymId()+"--"+oymDataRef+" Error:"+error);
		})

		// )
	})
  }
  this.downloadInProgress=false;
  this.loadOYMData = async function (){
	// console.log("loadOYMData checkpoint 0.5:"+this.fileToLoad+"--"+this.oymId());
	let fileName=this.fileToLoad;
	// console.log("loadOYMData checkpoint 0.7:"+this.fileToLoad+"--"+this.oymId());
	if (this.downloadInProgress){
		console.log("Download already in progress for"+fileName+".  This request ignored.")
		return;
	}
	// console.log("loadOYMData checkpoint 1.0:"+fileName+"--"+this.oymId());
	const storage = getStorage(app);
	const oymDataRef = ref(storage,fileName); 
	// console.log("loadOYMData checkpoint 2.0");
	getDownloadURL(oymDataRef).then((url) => {
		// console.log("loadOYMData checkpoint 3.0 ",url);
		const xhr = new XMLHttpRequest();
		xhr.open('GET', url);
		xhr.responseType = 'json';
		// console.log("loadOYMData checkpoint 4.0",url);
		xhr.onload = (event) => {
			this.data = xhr.response;
			// console.log("loadOYMData checkpoint 5.0. Data received.",this.data);
			this.downloadInProgress=false;
			this.isLoadRequested=false;
			objectRegistration("oymData",this.data,this.objectPool);
			// buildMinistryAndOversightMembership(this);
			// console.log("built? ",this.ministryAndOversightMembership);
			let newOYM = new OYMData(this.isDataPrivate);
			newOYM.data = this.data;
			newOYM.objectPool = this.objectPool;
			this.doneLoad(newOYM);  // callback
		  };
		xhr.onabort= (event) => {
			alert("load of "+oymDataRef+" aborted.");
			console.log("load of "+oymDataRef+" aborted.", event);
		}
		// console.log("loadOYMData checkpoint 6.0",url);
		xhr.send();
		// console.log("loadOYMData checkpoint 7.0. xhr request sent",xhr);
	}).catch((error) =>{
		console.log("loadOYMData error in getDownloadURL",error);
	})
}


	
  function processXHRError(xhr){
	alert("Error loading OYM data.  Contact technical support and give them this information:"+
	      xhr.status+":"+xhr.responseText);
  }
//   this.loadPublicOYMData();
//   objectRegistration("oymData",this.data,this.objectPool);//. commented out 12/20/2022
//   console.log(this.objectPool);
  /*  An object in the OYMData object graph may be represented either by the object itself or a
      Java Object id that has been "trimed".  For example, one id for a Friend object is Friend555cf22.
	  
	  ObjectRef is used to ensure that the object obtained from the object graph is a JavaScript
	  object and not an id.
  
      Calling objectRef requires knowledge of the object.  Java lists converted to JSON objects
      become two dimensional arrays, the first element of the first dimension is a string that
      identifies the type of object in the list.  The second element is an array representing the list.

      The two dimensional array also occurs in the JSON objects when representing a Java subclass.  The first
      element in the first dimension is a string that identifies the subclass.  The second is an array with
      one element which is the object.  objectRef will take care of this situation.

      On the other hand, references to a list in the OYM data object should never use objectRef.
      It is assumed that references to lists are known to be lists and not object
      references.   So a list reference in an object would look like...
            object.listReference[1]
  */
  this.objectRef = function (reference){
    // console.log("ObjectRef",reference);
    // console.log("ObjectRef",typeof reference);
    if (Array.isArray(reference)){
        return this.objectRef(reference[1])
    }
  	if (typeof reference == 'object'){
  		return reference;
  	}
  	return this.objectPool[reference];
  }
//   as of 2023.05.11 this has not been tested.
  this.isServing = function(service,friend){
	let serviceObject= this.objectRef(service);
	let friendObject=this.objectRef(friend);
	let foundFriend=serviceObject.members[1].find(friendToCheck => {
		let friendToCheckObject=this.objectRef(friendToCheck);
		return (friendToCheckObject==friendObject);
	});
	if (foundFriend==null){
		return false;
	}
	return true;
  }
  this.whichministryAndOversightService = function(friend){
	let friendObject=this.objectRef(friend);
	let ministryServiceObject=this.objectRef(this.data.ministryAndOversight.ministers);
	let ministryServiceObjects=[];
	// console.log("ministryServiceObject",ministryServiceObject);
	// console.log("ministryServiceObject.tenuresOfThoseServing[1]",ministryServiceObject.tenuresOfThoseServing[1]);
	let foundTenure=ministryServiceObject.tenuresOfThoseServing[1].find(tenure =>{
		let tenureObject=this.objectRef(tenure);
		let tenuredFriendObject=this.objectRef(tenureObject.friend);
		if (tenuredFriendObject===friendObject){
			// console.log("Minister Matched",friendObject);
			return true;
		} else {
			return false;
			// console.log("Minister not Matched",friendObject);
		}
	});
	if (foundTenure!=null){
		ministryServiceObjects.push(ministryServiceObject);
	} else {
		// console.log("no minister found");
	}
	let elderServiceObject=this.objectRef(this.data.ministryAndOversight.elders);
	foundTenure=elderServiceObject.tenuresOfThoseServing[1].find(tenure =>{
		let tenureObject=this.objectRef(tenure);
		let tenuredFriendObject=this.objectRef(tenureObject.friend);
		if (tenuredFriendObject===friendObject){
			return true;
		} else {
			return false;
		}
	});
	if (foundTenure!=null){
		ministryServiceObjects.push(elderServiceObject);
		// return elderServiceObject;
	} else {
		// console.log("no elder found");
	}
	let overseerServiceObject=this.objectRef(this.data.ministryAndOversight.overseers);
	foundTenure=overseerServiceObject.tenuresOfThoseServing[1].find(tenure =>{
		let tenureObject=this.objectRef(tenure);
		let tenuredFriendObject=this.objectRef(tenureObject.friend);
		if (tenuredFriendObject===friendObject){
			return true;
		} else {
			return false;
		}
	});
	if (foundTenure!=null){
		ministryServiceObjects.push(overseerServiceObject);
		// return overseerServiceObject;
	} else {
		// console.log("no overseer found");
	}
	// console.log("ministryServiceObjects",ministryServiceObjects);
	return ministryServiceObjects;
  }

  this.compareFriend = function(friend1,friend2){
     if (friend1.sortKey < friend2.sortKey){
      return -1;
    }
    if (friend1.sortKey > friend2.sortKey){
      return 1;
    }
    return 0;
  }
  this.compareOYMObject = function(object1,object2){
    if (object1.name < object2.name){
      return -1;
    }
    if (object1.name > object2.name){
      return 1;
    }
    return 0;
  }
  /*  	This method will take an email and return a name associated with it,
  		or return null if no email exists on the object graph.

		Emails can be associated with Friends and/or
		Households.  A household object contans an array of emails and each 
		friend object contains an email property.  Each email in the household
		array may, or may not, be duplicated in a friend object. 
		
		Although the data model allows for multiple members of a household to have
		been assigned the same email, this is not likely.  Emails are expected
		to be parsed from household data.  Emails are often associated
		with head of household and their spouse.  Additional members of
		the household are expected to have null emails.
		
  */
  this.isEmail = function(email){
	if (!isDataPrivate){
		return null;
	}
	if (this.data==null){
		console.log("isEmail called while data is null.",this);
		return null;
	} 
	// let wasDataPublic=isDataPublic;
	// if (isDataPublic){
	// 	console.log("Loading Private data for search");
  	// 	this.loadPrivateOYMData();
	// }
	email=email.toLowerCase();
	// console.log("in email ");
	// console.log(this.data);
	console.log(this.fileToLoad,this.oymId,this.data);
	let objectToReturn=null;
	for (let friendx in this.data.friends[1]){
		//   console.log(this.data.friends[1][friendx]);

		let friendObject=this.objectRef(this.data.friends[1][friendx]);
		if (friendObject.emailAddress!==null&&friendObject.emailAddress.toLowerCase()===email){
			console.log("matched on email address:"+friendObject.emailAddress);
			objectToReturn = friendObject; //.name;
			break;
		} 
		// console.log("No match on email address:"+friendObject.emailAddress);
		let householdObject=this.objectRef(friendObject.household);
		// console.log(householdObject);
		/* 	look through members of household before looking through
			list of household emails, so that they can be associated
			with a Friend name if possible.
		*/
		if (householdObject!==null&&householdObject.members!==null){
			for (let membersx in householdObject.members[1]){
				let memberObject = this.objectRef(householdObject.members[1][membersx]);
				// console.log(memberObject);
				if (memberObject.emailAddress!==null&&memberObject.emailAddress.toLowerCase()===email){
					objectToReturn =  memberObject; //.name;
					break;  // break household loop
				}
			}
			if (objectToReturn!=null){
				break;   // break friend loop
			}
		}
		if (householdObject!==null&&householdObject.emailAddresses!==null){
			for (let emailx in householdObject.emailAddresses[1]){
				let householdEmail = householdObject.emailAddresses[1][emailx];
				if (householdEmail!==null&&householdEmail.toLowerCase()===email){
					let householdHeadObject=this.objectRef(householdObject.head);			
					objectToReturn =  householdHeadObject; //.lastName+" household";
					break;
				}
			}
		}
	}
	return objectToReturn;
  }

;
}